import React, { useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import type { AppProps } from 'next/app';
import { ConfigProvider } from 'antd';
import ReduxLayout from 'store/with-redux-store';
import request, { requestMonitor } from 'services/request';
import theme from 'services/theme';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import Router, { useRouter } from 'next/router';
import 'public/css/fontiran.css';
import 'public/css/antd-rtl.css';
import 'public/css/public.css';
import 'public/css/icon.css';
import 'antd/dist/antd.css';
import { AffiliateUrl } from 'services/routes';
import Cookies from 'js-cookie';

NProgress.configure({
  minimum: 0.3,
  easing: 'ease',
  speed: 800,
  showSpinner: false,
});

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

const EnigmaApp = ({ Component, pageProps }: AppProps): React.ReactElement => {
  const router = useRouter();
  const { refId } = router.query;
  useEffect(() => {
    if (!request.monitors.length) {
      request.addMonitor(requestMonitor);
    }
  }, []);

  const getData = async (): Promise<void> => {
    const res: any = await request.post(AffiliateUrl(), { refId }); // eslint-disable-line
    res.ok &&
      res.data.expire_days &&
      Cookies.set('taalei-ref', refId, { expires: res.data.expire_days });
  };
  useEffect(() => {
    refId && getData();
  }, [refId]);

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider direction="rtl">
        <ReduxLayout>
          <Component {...pageProps} />
        </ReduxLayout>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default EnigmaApp;
